import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useTranslation } from "react-i18next";

const WindowsInstructions = ({ useMacUrl = false }) => {
  const { t } = useTranslation();
  const downloadUrl = useMacUrl
    ? "https://github.com/utkarshdalal/GameAway-moonlight/releases/download/v1.0.1/GameAway-1.0.1.dmg"
    : "https://github.com/utkarshdalal/GameAway-moonlight/releases/download/v1.0.1/GameAwaySetup-1.0.1.exe";

  return (
    <div>
      <div className="self-stretch flex-col justify-start items-start gap-1 flex">
        <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
          <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
            <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
              1
            </div>
          </div>
          <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-start gap-2 inline-flex w-full">
            <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
              Download our GameAway app
            </div>
            <button className="rounded-xl bg-gray-800 px-4 py-2 text-neutral-50">
              <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
                Click to download
              </a>
            </button>
            {!useMacUrl && (
              <div className="text-[var(--muted-foreground)] gap-2">
                <div className="pb-2">
                  {t("instruction_windows_app_error_1")}
                </div>
                <img
                  className="w-fit pb-2"
                  src="./windows-app-download-error-1.png"
                  alt="windows app download error"
                />
                <div className="pb-2">
                  {t("instruction_windows_app_error_2")}
                </div>
                <img
                  className="w-fit"
                  src="./windows-app-download-error-2.png"
                  alt="windows app download error fix"
                />
              </div>
            )}
          </div>
        </div>
        <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
          <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
            <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
              2
            </div>
          </div>
          <div className="grow shrink basis-0 text-neutral-50 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
            <div className="self-stretch text-xl font-semibold leading-7">
              Power On
            </div>
            <div className="self-stretch text-[var(--muted-foreground)]">
              {t("instruction_power_on_1_alt")}
            </div>
          </div>
        </div>
        <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
          <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
            <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
              3
            </div>
          </div>
          <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-center gap-2 inline-flex">
            <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
              Start Playing on GameAway!
            </div>
            <div className="self-stretch">
              <span className="text-[var(--muted-foreground)] font-normal leading-normal">
                {t("instruction_start_mac_pc")}
              </span>
            </div>
          </div>
        </div>
        <div className="self-stretch pb-6 justify-center items-start gap-4 inline-flex">
          <div className="w-10 h-10 p-2 bg-gray-800 rounded-full justify-center items-center flex overflow-hidden">
            <div className="w-6 h-6 text-center text-neutral-50 text-lg font-bold leading-7">
              4
            </div>
          </div>
          <div className="grow shrink basis-0 pt-1.5 flex-col justify-start items-start gap-2 inline-flex">
            <div className="self-stretch text-neutral-50 text-xl font-semibold leading-7">
              Shut down
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-2 flex">
              <div className="self-stretch text-muted-foreground font-normal leading-normal">
                {t("instruction_shut_down")}
              </div>
              <div className="pl-1.5 pr-2 py-2 bg-[#2f2f2f] rounded-xl justify-start items-center gap-3 inline-flex overflow-hidden">
                <img
                  className="h-[84.07px]"
                  src="./steam-cloud.png"
                  alt="steam cloud"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WindowsInstructions;
